import { useState, useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import ClearIcon from '@mui/icons-material/Clear';
//-----------------------------------------------------------------------
import AiAgentSvg from 'layout/MainLayout/Header/AiAgentSection/AiAgentSvg'

import Loading from "ui-component/Loading";
import ApiService from "services/ApiService";
import SecurityService from "services/SecurityService";
//-----------------------------------------------------------------------

const AiAgent = () => {
    const { t } = useTranslation();

    const theme = {
      primary_color: '222f69',
      secondary_color: '068054',
      success_color: '39bb6c',
      info_color: '4eb6cc',
      warning_color: 'f48f36',
      error_color: 'ca4040',
      neutral_color: 'd5d5d5',
      empty_color: '7d7d7d',
      font_family: 'Poppins'
    }

    const [loading, set_loading] = useState(true);
    const [url, set_url] = useState(null);
    const [current_locale, set_current_locale] = useState(SecurityService.getUserLocale());

    const getUrl = () => {
      let url = window.env.GENERIC_FRONTEND_REACTJS_AI_AGENT +
        "/?subdomain=customs" +
        "&user_id=" + SecurityService.getUserId() +
        "&token=" + SecurityService.getUserToken() +
        "&embebbed=true" +
        "&locale=" + SecurityService.getUserLocale() +
        "&primary_color=" + theme.primary_color +
        "&secondary_color=" + theme.secondary_color +
        "&success_color=" + theme.success_color +
        "&info_color=" + theme.info_color +
        "&warning_color=" + theme.warning_color +
        "&error_color=" + theme.error_color +
        "&neutral_color=" + theme.neutral_color +
        "&empty_color=" + theme.empty_color +
        "&font_family=" + theme.font_family;

        return url;
    }

    const updateUrl = (() => {
      setTimeout(function() {
        if (ApiService.isBusy()) {
          updateUrl();
          return;
        }

        set_url(getUrl());
      }, 1500);
    });

    const updateCurrentLocale = (() => {
      set_current_locale(SecurityService.getUserLocale());
      updateUrl();
    });

    useEffect(() => {
      if (!url) {
        return updateUrl();
      }

      if (current_locale !== SecurityService.getUserLocale()) {
        return updateCurrentLocale();
      }

      // Register AI Agent actions listener...
      window.addEventListener("message", onRecievedMessage);

      return () => {
        window.removeEventListener("message", onRecievedMessage)
      }
    });

    const onRecievedMessage = (event) => {
        event.stopPropagation();
        if (event.data.constructor !== Object) return;
        if (event.data.type !== 'ai-agent-message-action') return;

        if (event.data.action === 'ai_agent_is_ready') return sendStartupAlerts();
        if (event.data.action === 'update_user_profile') return document.getElementById('update_user_profile').click();
    };

    const sendStartupAlerts = () => {
      setTimeout(() => {
        // User profile photo alert...
        if (!SecurityService.getMainUserPhotoUrl()) {
          MessageService.showInfoNotification(t("Have you considered to update your profile avatar?"), "update_user_profile", t("Update user profile now"));
        }
        
        // User access code alert...
        if (SecurityService.userHasExpirationDate()) {
          let expiration_date = SecurityService.getPasswordExpirationDate();
          let expiration_time = SecurityService.getPasswordExpirationTime();
          MessageService.showInfoNotification(t("Your access code will expired at " + expiration_date + " " + expiration_time + ". You must to change your password as soon as possible."), "update_user_profile", t("Update user profile now"));
        }
      }, 1000);
    }

    const onAiAgentLoad = () => {
      if (!loading) return;
      set_loading(false);
    }

    const closeAiAgent = () => {
      document.getElementById('root').classList.remove('ai-agent-oppened');
    }

    return (
      <div id="ai-agent">
        {
          <div id="ai-agent-title">
            <h1>
              <div style={{float: 'left', marginTop: '-3px', marginRight: '5px'}}>
                <AiAgentSvg color="#364152" />
              </div>
              {t('Earground Assist')}
            </h1>
            <ClearIcon id="ai-agent-close" onClick={() => closeAiAgent()} />
          </div>
        }

        {
          loading &&
          <Loading style={{marginTop: '25px'}} />
        }

        {
          url &&
          <iframe 
            id="ai-agent-iframe"
            title="ai-agent"
            onLoad={onAiAgentLoad}
            src={url}
            style={{display: (loading ? 'none' : 'block')}}
          />
        }
      </div>
    );
};

export default AiAgent;
